/** RFC 7807 problem details. Declared here rather than taken from a generated `types.ts`, so every API package can share it. */
export type ProblemDetails = {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
} & {
    [key: string]: unknown;
};

function isProblemDetails(error: unknown): error is ProblemDetails {
    if (typeof error !== "object" || error === null) {
        return false;
    }

    return "title" in error || "detail" in error || "status" in error;
}

export type ValidationProblemDetails = ProblemDetails & { errors: Record<string, string[]> };

export function isValidationProblemDetails(error: unknown): error is ValidationProblemDetails {
    if (!isProblemDetails(error)) {
        return false;
    }

    const { errors } = error as { errors?: unknown };

    return (
        typeof errors === "object" &&
        errors !== null &&
        !Array.isArray(errors) &&
        Object.values(errors).every(v => Array.isArray(v) && v.every(item => typeof item === "string"))
    );
}

export function getErrorMessage(error: unknown, defaultMessage: string): string {
    if (isProblemDetails(error)) {
        return error.detail || error.title || defaultMessage;
    }

    return defaultMessage;
}
